var _circle, _rect, _path, _circle2, _path2, _circle3, _path3, _rect2, _rect3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 262,
    viewBox: "0 0 357 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 126.5,
    r: 126.5,
    fill: "#DEDFE4",
    fillOpacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 166,
    width: 47,
    height: 47,
    fill: "#FFD1CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 119L47 166V166C21.0426 166 4.76623e-06 144.957 5.90086e-06 119V119L47 119Z",
    fill: "#2D3E91"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 193,
    r: 21,
    fill: "#F86969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268 210C274.837 210 281.395 212.716 286.23 217.55C291.064 222.384 293.781 228.94 293.781 235.776C293.781 242.612 291.064 249.168 286.23 254.002C281.395 258.836 274.837 261.552 268 261.552L268 235.776L268 210Z",
    fill: "#91CED2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 20.6938,
    transform: "matrix(-1 0 0 1 311.086 147.694)",
    fill: "#FFD1CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M356.78 201.5C356.78 184.103 342.677 170 325.28 170H293.78V233H325.28C342.677 233 356.78 218.897 356.78 201.5V201.5Z",
    fill: "#2D3E91"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 142,
    width: 102,
    height: 26,
    rx: 13,
    transform: "rotate(-90 175 142)",
    fill: "#2D3E91"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 235.952,
    y: 172.017,
    width: 75,
    height: 26,
    rx: 13,
    transform: "rotate(-150 235.952 172.017)",
    fill: "#BAE4E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 129,
    r: 13,
    fill: "#91CED2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.c59b5729cdafa4a14123d7bf32bc1ea0.svg";
export { ForwardRef as ReactComponent };